export const PlusIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.38464 0.5V8.305H0.5V13.5083H8.38464V21.3133H13.6411V13.5083H21.5257V8.305H13.6411V0.5H8.38464Z"
      fill="#F06D24"
    />
  </svg>
);
